import React from 'react';
import type QueryFilter from '../../helpers/query-filter';

interface Filter {
  id: string;
  displayName: string;
  tagDisplayName?: string;
}

interface FilterFoldoutCheckboxPRops {
  filter: Filter;
  queryFilter: QueryFilter;
  excluding?: boolean;
  onChange: (queryFilter: QueryFilter) => void;
}

const FilterFoldoutCheckbox = ({
  filter,
  queryFilter,
  onChange,
  excluding,
}: FilterFoldoutCheckboxPRops) => {
  const onToggleFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();

    let nextQueryFilter = queryFilter;
    if (queryFilter.has(filter.id)) {
      nextQueryFilter = nextQueryFilter.remove(filter.id);
    } else {
      nextQueryFilter = nextQueryFilter.add(filter.id, excluding ? 'false' : 'true');
    }

    onChange(nextQueryFilter);
  };

  return (
    <li className="filter-toggle-list-item">
      <div className="filter-toggle-list-switch">
        <div data-wx-switch="">
          <input
            type="checkbox"
            className="checkbox"
            id={`fo-${filter.id}`}
            checked={queryFilter.has(filter.id)}
            name="filter-container"
            onChange={onToggleFilter}
          />
          <label htmlFor={`fo-${filter.id}`} aria-label="toggle" className="switch" />
        </div>
      </div>
      <label htmlFor={`fo-${filter.id}`} className="filter-toggle-list-label">
        {filter.displayName}
      </label>
    </li>
  );
};

export default FilterFoldoutCheckbox;
